<template>
  <div>
    <IndexNavbar />
    <main>
      <section class="pt-20 pb-48">
        <div class="container mx-auto px-4" style="margin-top: 50px;">
          <div class="flex flex-wrap justify-center text-center" >
            <div class="w-full lg:w-12/12">
              <h2 class="text-4xl font-semibold">Partners</h2>
              <p class="text-lg leading-relaxed m-4 text-blueGray-600 text-left" style="margin-bottom: 1rem;">
                At AmeiseTech, we are proud to collaborate with visionary companies and industry leaders. These partnerships allow us to deliver innovative, robust solutions to our shared clients.             
               </p>
              <h3 class="text-2xl leading-relaxed m-4 text-blueGray-600 text-left" style="line-height: 0rem !important;">Ab-ovo</h3>
                 <p class="text-lg leading-relaxed m-4 text-blueGray-600 text-left">Ab-ovo is a trusted consulting partner specializing in strategic advisory, operational excellence, and digital transformation. Their expertise helps organizations streamline processes, improve decision-making, and achieve measurable business outcomes. Through our partnership, we deliver end-to-end solutions that combine strategic insight with scalable technology.</p>
              <h3 class="text-2xl leading-relaxed m-4 text-blueGray-600 text-left" style="line-height: 0rem !important;">Sterlite Technologies Limited</h3>
                 <p class="text-lg leading-relaxed m-4 text-blueGray-600 text-left">Sterlite Technologies Limited (STL) is a global leader in digital and optical networking solutions, enabling robust and future-ready communication infrastructure. Our collaboration with STL strengthens our capability to deliver secure, high-performance, and scalable technology solutions for large-scale infrastructure and enterprise deployments.</p>
              <h3 class="text-2xl leading-relaxed m-4 text-blueGray-600 text-left" style="line-height: 0rem !important;">Tera Software</h3>
                  <p class="text-lg leading-relaxed m-4 text-blueGray-600 text-left">Tera Software is a technology services provider with deep expertise in system integration, enterprise applications, and digital platforms. Together, we focus on delivering reliable, scalable, and secure software solutions tailored to complex operational environments across industries.</p>
              </div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
              <div class="px-6">
                <div class="logo-circle mx-auto shadow-lg">
                <img
                  alt="..."
                  :src="partner1"
                  class="logo-img shadow-lg rounded-full mx-auto max-w-120-px"
                />
              </div>
                <div class="pt-6 text-center">
                  <h5 class="text-ml font-bold">Ab-ovo</h5>
                </div>
              </div>
            </div>
            <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
              <div class="px-6">
                <div class="logo-circle mx-auto shadow-lg">
                <img
                  alt="..."
                  :src="partner2"
                  class=" logo-img shadow-lg rounded-full mx-auto max-w-120-px" 
                />
                </div>
                <div class="pt-6 text-center">
                  <h5 class="text-ml font-bold">Sterlite Technologies Limited</h5>
                </div>
              </div>
            </div>
            <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
              <div class="px-6">
                <div class="logo-circle mx-auto shadow-lg">
                <img
                  alt="..."
                  :src="partner3"
                  class=" logo-img shadow-lg rounded-full mx-auto max-w-120-px" 
                />
                </div>
                <div class="pt-6 text-center">
                  <h5 class="text-ml font-bold">Tera Software</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container mx-auto px-4" style="margin-top: 50px;">
          <div class="flex flex-wrap justify-center text-center"  style="margin-bottom: 1rem;">
            <div class="w-full lg:w-12/12">
              <h2 class="text-4xl font-semibold">Clients</h2>
              <p class="text-lg leading-relaxed m-4 text-blueGray-600 text-left">
We are proud to serve a diverse portfolio of clients across infrastructure, logistics, manufacturing, public sector, and sustainability-focused organizations. Our client relationships are built on trust, transparency, and measurable outcomes.              </p>
</div>
          </div>
          <div class="flex flex-wrap">
           <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
              <div class="px-6">
                <div class="logo-circle mx-auto shadow-lg">
                <img
                  alt="..."
                  :src="partner1"
                  class="logo-img shadow-lg rounded-full mx-auto max-w-120-px"
                />
              </div>
                <div class="pt-6 text-center">
                  <h5 class="text-ml font-bold">Ab-ovo</h5>
                </div>
              </div>
            </div>
            <div class="w-full md:w-6/12 lg:w-3/12 lg:mb-0 mb-12 px-4" style="width: 20%;">
              <div class="px-6">
                <div class="logo-circle mx-auto shadow-lg">
                <img
                  alt="..."
                  :src="client1"
                  class=" logo-img shadow-lg rounded-full mx-auto max-w-120-px" 
                />
                </div>
                <div class="pt-6 text-center">
                  <h5 class="text-ml font-bold">JNPA</h5>
                </div>
              </div>
            </div>
          
          </div>
        </div>

 <!-- TEAM SECTION -->
<div class="container mx-auto px-4" style="margin-top: 50px;">
  <div class="flex flex-wrap justify-center text-center mb-6">
    <div class="w-full lg:w-12/12">
      <h2 class="text-4xl font-semibold">Our Team</h2>
      <p class="text-lg leading-relaxed m-4 text-blueGray-500 text-left">
  Our team is composed of experienced leaders, domain specialists, and technology
  professionals who bring together strong industry knowledge and hands-on execution
  capabilities. With backgrounds spanning infrastructure, consulting, software
  engineering, and digital transformation, our team is well-equipped to address
  complex, real-world challenges across sectors.
</p>

<p class="text-lg leading-relaxed m-4 text-blueGray-500 text-left">
  The leadership team provides strategic direction and ensures that every engagement
  is aligned with client objectives, regulatory requirements, and long-term value
  creation. They work closely with project teams to maintain high standards of
  delivery, governance, and accountability throughout the engagement lifecycle.
</p>

<p class="text-lg leading-relaxed m-4 text-blueGray-500 text-left">
  Our core delivery team brings deep technical expertise in software development,
  system integration, data platforms, and analytics. Team members collaborate
  closely across functions to design scalable, secure, and maintainable solutions
  that integrate seamlessly into client environments.
</p>

<!-- <p class="text-lg leading-relaxed m-4 text-blueGray-500 text-left">
  We place strong emphasis on collaboration, continuous learning, and practical
  problem-solving. This culture enables our team to adapt quickly to evolving
  project requirements, emerging technologies, and changing regulatory landscapes,
  while consistently delivering reliable and high-quality outcomes.
</p> -->

    </div>
  </div>

  <div class="flex flex-wrap justify-center">
    <div
      v-for="(member, index) in teamMembers"
      :key="index"
      class="w-full md:w-6/12 lg:w-3/12 mb-12 px-4"
      style="width: 20%;"
    >
      <div class="px-6">
        <div class="logo-circle mx-auto shadow-lg">
          <img
            :src="member.photo"
            alt="team member"
            class="logo-img rounded-full"
          />
        </div>
        <div class="pt-6 text-center">
          <h5 class="text-ml font-bold">{{ member.name }}</h5>
          <p class="text-sm text-blueGray-500">{{ member.role }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
      </section>
 
     

    </main>
    <footer-component />
  </div>
</template>
<script>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import partner1 from "@/assets/img/PPR0001023_1colored.png";
import partner2 from "@/assets/img/sterlite technologies limited.jpg";
import partner3 from "@/assets/img/teralogo.png";
import client1 from "@/assets/img/my-logo.png";
import client2 from "@/assets/img/jnpt1.png";
import client3 from "@/assets/img/jnpa-logo.png";


import ceo from "@/assets/img/jayant kohale.jpg";
import partner from "@/assets/img/02.jpg";
import team1 from "@/assets/img/01.jpg";
import team2 from "@/assets/img/Lavkush.jpeg";
import team3 from "@/assets/img/Bhushan.png";
import team4 from "@/assets/img/Sheetal.png";
import team5 from "@/assets/img/sandeep-pal.png";

export default {
  data() {
    return {
      partner1,
      partner2,
      partner3,
      client1,
      client2,
      client3,
      ceo,
      partner,
      team1,
      team2,
      team3,
      team4,
      team5,

       teamMembers: [
  {
    name: "Jayant Kohale",
    role: "Chief Executive Officer (CEO)",
    photo: ceo,
  },
  {
    name: "Krunal Sidhpura",
    role: "Co-Founder & Partner",
    photo: partner,
  },
  {
    name: "Abhishek Kumar",
    role: "Consultant",
    photo: team1,
  },
  {
    name: "Lavkush kumar",
    role: "Software Engineer",
    photo: team2,
  },
  {
    name: "Bhushan Shinde",
    role: "Project Developer",
    photo: team3,
  },
  {
    name: "Sheetal Salvi",
    role: "Software Developer",
    photo: team4,
  },
  {
    name: "Sandeep Pal",
    role: "Software Development",
    photo: team5,
  },
],
    };
  },
  components: {
    IndexNavbar,
    FooterComponent,
  },

 

};
</script>
<style scoped>
  .logo-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* IMPORTANT */
}
.logo-circle:hover {
  transform: translateY(-6px) scale(1.05);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  background-color: #eaeaea;
}

.logo-img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}
.pt-6 {
    padding-top: 0.5rem;
}
</style>